import { JsonPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha-2';
import { Subject, map, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginPayload } from '../../../models/login-payload.model';
import { LoginUserType, ProgramProductConfig } from '../../../models/program-product-config.model';


@Component({
  selector: 'seth-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDividerModule,
    MatRadioModule,
    MatButtonModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatSelectModule,
    MatIconModule    
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.RECAPTCHA_SITE_KEY } as RecaptchaSettings,
    },
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit, OnDestroy {
  @Input() programProductConfig: ProgramProductConfig[] = [];
  @Input() userTypes: LoginUserType[] = [];
  @Input() hideSingleOptions: boolean = false;
  @Output() loginPayload = new EventEmitter<LoginPayload>();
  private _fb: FormBuilder = inject(FormBuilder);
  private _destroy$: Subject<boolean> = new Subject<boolean>();
  selectedProgramConfig: ProgramProductConfig = {program: '', products: [], allowMultipleProductSelection: false};
  form: FormGroup = this._fb.group({
    userType: ['', Validators.required],
    program: ['', Validators.required],
    product: ['', Validators.required],
    recaptcha: [null, environment.SHOW_RECAPTCHA ? Validators.required : null],
  });

  ngOnInit(){

    if(this.userTypes.length === 1){
      this.form.get('userType')?.setValue(this.userTypes[0].defaultWorkflow);
    }

    if(this.programProductConfig.length === 1){
      this.form.get('program')?.setValue(this.programProductConfig[0].program);
      this.selectedProgramConfig = this.programProductConfig[0];

      if(this.programProductConfig[0].products.length === 1){
        this.form.get('product')?.setValue(this.programProductConfig[0].products[0]);
      }
    }

    this.form.get('program')?.valueChanges.pipe(takeUntil(this._destroy$), map(value => {
      const config = this.programProductConfig.find(item => item.program === value);
      if(config){
        this.selectedProgramConfig = config;
      }
      this.form.get('product')?.setValue('');
    })).subscribe();

  }

  begin(){
    this.form.markAllAsTouched();
    if(this.form.invalid) return;

    const productSelection = this.form.get('product')?.value;

    const payload: LoginPayload = {
      userType: this.form.get('userType')?.value,
      program: this.form.get('program')?.value,
      products: Array.isArray(productSelection) ? productSelection : [productSelection],
    }

    this.loginPayload.emit(payload);
  }

  ngOnDestroy(){
    this._destroy$.next(false);
    this._destroy$.unsubscribe();
  }
}
